__turbopack_context__.v({
  "section": "recently-viewed-products-module-scss-module__hq7hyq__section",
});
